function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 1 -.0002528 -283.78)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.117 0 0 .117 .75773 284.48)",
  clipRule: "evenodd",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m20.574 64.951h11.054c-0.673-1.912-1.123-3.93-1.318-6.023h-8.533c-7.975 0-14.44-6.473-14.44-14.456s6.466-14.456 14.44-14.456h21.862c7.977 0 14.441 6.473 14.441 14.456 0 6.489-4.268 11.978-10.146 13.806 0.824 1.5 2.18 3.689 3.862 5.385 7.772-2.903 13.304-10.397 13.304-19.191 0-11.31-9.158-20.479-20.458-20.479h-24.068c-11.299 0-20.458 9.17-20.458 20.479 0 11.313 9.159 20.479 20.458 20.479z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m35.015 56.52c0 11.311 9.16 20.48 20.458 20.48h24.068c11.3 0 20.459-9.17 20.459-20.48 0-11.312-9.159-20.48-20.458-20.48h-11.071c0.677 1.913 1.13 3.931 1.33 6.023h8.738c7.974 0 14.439 6.474 14.439 14.457 0 7.984-6.466 14.457-14.439 14.457h-21.862c-7.976 0-14.442-6.473-14.442-14.457 0-6.615 4.437-12.19 10.495-13.908-0.447-2.259-1.676-4.238-3.4-5.632-8.296 2.612-14.315 10.372-14.315 19.54z"
})));

var SvgUrl = function SvgUrl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 13.229 13.229",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUrl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/url.84ab2031.svg";
export { ForwardRef as ReactComponent };